// Noodle & Snoot: legacy Custom Size show/hide/validate script.
// Isolated into this static asset file 1 August 2026 as part of the
// Dawn-update isolation refactor (see Protected Custom Code Registry,
// item 2). This is inherited site infrastructure that pre-dates the
// project's session log; previously embedded directly in
// layout/theme.liquid, which is exactly the kind of file a Dawn
// theme-engine update can silently overwrite. Only a single <script
// src> reference line now lives in theme.liquid; that line is
// trivial to restore even if a merge drops it, unlike this file's
// full content. Behaviour is unchanged from the original.
(function() {
  // Check whether "Custom Size" is currently selected
  function isCustomSizeSelected() {
    var selected = false;

    // Radio-style variant buttons
    var radios = document.querySelectorAll('input[type="radio"][value="Custom Size"]');
    radios.forEach(function(radio) {
      if (radio.checked) selected = true;
    });

    // Dropdown variants
    var selects = document.querySelectorAll('select');
    selects.forEach(function(sel) {
      if (sel.value === 'Custom Size') selected = true;
    });

    return selected;
  }

  // Show / hide the custom measurements box
  function updateCustomSizeVisibility() {
    var fields = document.getElementById('custom-size-fields');
    if (!fields) return;
    fields.style.display = isCustomSizeSelected() ? 'block' : 'none';
  }

  // Make sure Neck / Chest / Back length are filled in
  function validateCustomSizeFields() {
    var fields = document.getElementById('custom-size-fields');
    if (!fields) return true; // nothing to validate

    var ids = ['custom-neck', 'custom-chest', 'custom-length'];
    var missing = [];

    ids.forEach(function(id) {
      var el = document.getElementById(id);
      if (el && !el.value.trim()) {
        missing.push(el);
      }
    });

    if (missing.length > 0) {
      alert('Please fill in Neck, Chest and Back length measurements for Custom Size.');
      fields.scrollIntoView({ behavior: 'smooth', block: 'center' });
      missing[0].focus();
      return false;
    }

    return true;
  }

  function setupCustomSizeBehaviour() {
    var fields = document.getElementById('custom-size-fields');
    if (!fields) return; // not on this page

    // Update visibility when options change
    document.addEventListener('change', function(e) {
      if (!e.target) return;
      if (e.target.matches('input[type="radio"], select')) {
        updateCustomSizeVisibility();
      }
    });

    // Initial state on load
    updateCustomSizeVisibility();

    // Intercept Add to cart button clicks
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('button, input[type="submit"]');
      if (!btn) return;

      // Find parent form for this button
      var form = btn.closest('form');
      if (!form) return;

      var action = form.getAttribute('action') || '';
      // Only affect add-to-cart forms
      if (action.indexOf('/cart/add') === -1) return;

      // If not Custom Size, don't interfere
      if (!isCustomSizeSelected()) return;

      // Validate fields for Custom Size
      if (!validateCustomSizeFields()) {
        e.preventDefault();
        e.stopImmediatePropagation(); // stop theme JS add-to-cart
      }
    });

    // Extra safety: also handle native submit
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      if (!isCustomSizeSelected()) return;

      if (!validateCustomSizeFields()) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCustomSizeBehaviour);
  } else {
    setupCustomSizeBehaviour();
  }
})();
